import React, { useState, useEffect } from "react";
import { GoHome } from "react-icons/go";
import { GiVacuumCleaner } from "react-icons/gi";
import { FaTruck, FaHammer } from "react-icons/fa";
import StepBreadcrumbs from "../components/StepBreadcrumbsProps";
import { subscribeToPrecios } from "../firebase/firebaseService"; 
import { useTranslation } from "react-i18next";

type Props = {
  setQuoteDetails: React.Dispatch<
    React.SetStateAction<{
      service: string;
      frequency: string;
      location: string;
      bedrooms: number;
      bathrooms: number;
      insideFridge: boolean,  // ✅ Agregamos estos valores directamente
      insideOven: boolean,
      insideCabinets: boolean,
      windows: boolean,
  
      contactDetails: {
        name: string;
        phone: string;
        address: string;
        email: string;
      }; // Se agregó esto
      price: number;
    }>
  >;
};


const ServiceSelection: React.FC<Props> = ({ setQuoteDetails }) => {
  const [selectedService, setSelectedService] = useState("");
  const [selectedFrequency, setSelectedFrequency] = useState("");
  const [selectedBedrooms, setSelectedBedrooms] = useState(0);
  const [selectedBathrooms, setSelectedBathrooms] = useState(0);
  const [basePrice, setBasePrice] = useState(0);

  const [precios, setPrecios] = useState<any[]>([]);
  const [frequencies, setFrequencies] = useState<any[]>([]);
  const [services, setServices] = useState<any[]>([]);
  const [preciosOrdenados, setPreciosOrdenados] = useState<any[]>([]);

  const { t, i18n } = useTranslation();

  useEffect(() => {
      // Escucha los cambios en la base de datos
      const unsubscribe = subscribeToPrecios((data) => {
        setPrecios(data);

        //console.log(precios)
      });
  
      // Cleanup: Detener la suscripción cuando el componente se desmonta
      return () => unsubscribe();
    }, []);

  

       
    useEffect(() => {
      if (precios.length > 3) {
        // Ordenar precios basado en el número dentro del id (ej. "servicio 1", "servicio 2", ...)
        const preciosOrdenados = [...precios].sort((a, b) => {
          const numA = parseInt(a.id.replace("servicio_", ""), 10);
          const numB = parseInt(b.id.replace("servicio_", ""), 10);
          return numA - numB; // Orden ascendente basado en número
        });

        setPreciosOrdenados(preciosOrdenados);
    
        // Actualizar los servicios con los primeros 4 datos ordenados
        setServices([
          { name: preciosOrdenados[0].servicio, price: preciosOrdenados[0].costo, icon: <GoHome className="w-[30px] h-[30px]" /> },
          { name: preciosOrdenados[1].servicio, price: preciosOrdenados[1].costo, icon: <FaTruck className="w-[30px] h-[30px]"/> },
          { name: preciosOrdenados[2].servicio, price: preciosOrdenados[2].costo, icon: <FaHammer className="w-[30px] h-[30px]"/> },
          { name: preciosOrdenados[3].servicio, price: preciosOrdenados[3].costo, icon: <GiVacuumCleaner className="w-[30px] h-[30px]"/> },
        ]);
    
        // Actualizar las frecuencias con los datos del 5 al 8
        setFrequencies([
          { name: preciosOrdenados[6].servicio, costo: preciosOrdenados[6].costo },
          { name: preciosOrdenados[7].servicio, costo: preciosOrdenados[7].costo },
          { name: preciosOrdenados[8].servicio, costo: preciosOrdenados[8].costo },
          { name: preciosOrdenados[9].servicio, costo: preciosOrdenados[9].costo },
        ]);
        //console.log(preciosOrdenados)
      }
    }, [precios]); // Se ejecuta cuando `precios` cambia
    
  
    const handleServiceChange = (service: any) => {
      setSelectedService(service.name);
      setBasePrice(service.price);
    
      // Mantener los valores ya seleccionados
      const frequencyCost = frequencies.find(freq => freq.name === selectedFrequency)?.costo || 0;
      const bedroomsCost = selectedBedrooms * (preciosOrdenados[4]?.costo || 0);
      const bathroomsCost = selectedBathrooms * (preciosOrdenados[5]?.costo || 0);
    
      // Calcular el nuevo precio manteniendo los valores previos
      const newPrice = service.price + frequencyCost + bedroomsCost + bathroomsCost;
    
      setQuoteDetails((prev) => ({
        ...prev,
        service: service.name,
        price: newPrice,
      }));
    };
    

  const handleFrequencyChange = (frequency: any) => {
    setSelectedFrequency(frequency.name);
    const newPrice =
    basePrice + frequency.costo + selectedBedrooms * preciosOrdenados[4].costo + selectedBathrooms * preciosOrdenados[5].costo;
  
    setQuoteDetails((prev) => ({
      ...prev,
      frequency: frequency.name,
      price: newPrice,
    }));
  };

  const handleBedroomsChange = (bedrooms: number) => {
    if (preciosOrdenados.length < 5) return; // Evita errores si los datos aún no han cargado
  
    setSelectedBedrooms(bedrooms);
    const newPrice =
      basePrice +
      (frequencies.find((freq) => freq.name === selectedFrequency)?.costo || 0) +
      bedrooms * preciosOrdenados[4].costo + // ✅ Usa el valor de la BD
      selectedBathrooms * preciosOrdenados[5].costo; // ✅ Para baños
  
    setQuoteDetails((prev) => ({
      ...prev,
      bedrooms,
      price: newPrice,
    }));
  };




  const handleBathroomsChange = (bathrooms: number) => {
    if (preciosOrdenados.length < 6) return; // Evita errores si los datos aún no han cargado
  
    setSelectedBathrooms(bathrooms);
    const newPrice =
      basePrice +
      (frequencies.find((freq) => freq.name === selectedFrequency)?.costo || 0) +
      selectedBedrooms * preciosOrdenados[4].costo + // ✅ Usa el valor de la BD para habitaciones
      bathrooms * preciosOrdenados[5].costo; // ✅ Usa el valor de la BD para baños
  
    setQuoteDetails((prev) => ({
      ...prev,
      bathrooms,
      price: newPrice,
    }));
  };


  return (
    <div className="p-6">
      <div>
        <StepBreadcrumbs currentStep={1} />
       
      </div>

      <hr className="border-t-2 mb-6"></hr>

      <h2 className="text-[12px] lg:text-[12px] text-textTitle font-bold mb-2">
      {t("serviceSelectiontitles.typeOfService")}  
      </h2>

      <div className="grid grid-cols-2 gap-4 lg:grid-cols-4">
        {services.map((service) => (
          <div
            key={service.name}
            onClick={() => handleServiceChange(service)}
            className={`border p-2 lg:p-4 py-4 lg:py-8 rounded-lg flex flex-col items-center cursor-pointer transition duration-300 
              ${
                selectedService === service.name
                  ? "border-bgPrimary border-[3px] text-textPrimary bg-blue-100"
                  : "bg-white border-gray-300 border-2 text-textTipic hover:bg-blue-100"
              }`}
          >
            <div className="text-2xl mb-2">{service.icon}</div>
            <span className="font-semibold text-[13px] lg:text-[12px]">{t(`servicesSelection.${service.name.toLowerCase().replace(/\s+/g, '-')}`)}
            </span>
          </div>
        ))}
      </div>

      <h2 className="text-[12px] lg:text-[12px] text-textTitle font-bold mb-2 mt-6 lg:mt-12">
      {t("serviceSelectiontitles.howOften")} 
      </h2>
      <div className="grid grid-cols-2 gap-4 lg:grid-cols-4">
        {frequencies.map((freq) => (
          <div
            key={freq.name}
            onClick={() => handleFrequencyChange(freq)}
            className={`border p-2 lg:p-4 rounded-lg cursor-pointer transition duration-300 text-[13px] lg:text-[12px] 
              ${
                selectedFrequency === freq.name
                  ? "border-bgPrimary border-[3px] text-textPrimary font-semibold bg-blue-100"
                  : "bg-white border-gray-300 border-2 text-textTipic hover:bg-blue-100 font-semibold"
              }`}
          >
            {t(`frequencies.${freq.name.replace(/\s+/g, '')}`)}
          </div>
        ))}
      </div>

      <h2 className="text-[12px] lg:text-[12px] text-textTitle font-bold mt-6 lg:mt-12">
      {t("serviceSelectiontitles.propertySize")}
      </h2>

      <div className="flex flex-col lg:flex-row lg:items-center items-start justify-left lg:gap-x-20 ">
        <div >
          <h2 className="text-[12px] lg:text-[12px] text-textTipic font-semibold mb-2 mt-4">
          {t("serviceSelectiontitles.numberOfBedrooms")}
          </h2>

          <div className="flex gap-4">
            {[1, 2, 3, 4, 5].map((num) => (
              <div
                key={num}
                onClick={() => handleBedroomsChange(Number(num))}
                className={`border lg:p-4 py-2 px-4 rounded-lg cursor-pointer transition duration-300 
              ${
                selectedBedrooms === num
                  ? "border-bgPrimary border-[3px] text-textPrimary font-semibold bg-blue-100"
                  : "bg-white border-gray-300 border-2 text-textTipic hover:bg-blue-100 font-semibold"
              }`}
              >
                {num}
              </div>
            ))}
          </div>
        </div>

        <div>
          <h2 className="text-[12px] lg:text-[12px] text-textTipic font-semibold mb-2 mt-4 ">
          {t("serviceSelectiontitles.numberOfBathrooms")}
          </h2>

          <div className="flex gap-4">
            {[1, 2, 3, 4, 5].map((num) => (
              <div
                key={num}
                onClick={() => handleBathroomsChange(num)}
                className={`border lg:p-4 py-2 px-4 rounded-lg cursor-pointer transition duration-300 
              ${
                selectedBathrooms === num
                  ? "border-bgPrimary border-[3px] text-textPrimary font-semibold bg-blue-100"
                  : "bg-white border-gray-300 border-2 text-textTipic hover:bg-blue-100 font-semibold"
              }`}
              >
                {num}
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ServiceSelection;
